// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import MarkdownPreviewController from "./markdown_preview_controller"
application.register("markdown-preview", MarkdownPreviewController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UploadStatusController from "./upload_status_controller"
application.register("upload-status", UploadStatusController)
